import React from "react";
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { HOME_PAGE, PRIVACY_PAGE, REFUND_PAGE, MARKET_PAGE, CHILD_SAFETY_PAGE } from "./constants/routes.constant";
import { HomePage } from "./pages/home/home.component";
import { PrivacyPage } from "./pages/privacy/privacy.component";
import { RefundPage } from "./pages/refund/refund.component";
import { MarketPage } from "./pages/market/market.component";
import { ChildSafetyPage } from "./pages/child-safety/child-safety.component";


function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Redirect exact from="/" to={HOME_PAGE} />
        <Route exact path={HOME_PAGE} component={HomePage} />
        <Route exact path={PRIVACY_PAGE} component={PrivacyPage} />
        <Route exact path={CHILD_SAFETY_PAGE} component={ChildSafetyPage} />
        <Route exact path={REFUND_PAGE} component={RefundPage} />
        <Route exact path={MARKET_PAGE} component={MarketPage} />
        <Route path='/' component={HomePage} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
